import {ChangeDetectorRef, Component} from '@angular/core';
import {SettingsService} from '../../services/settings.service';
import {BilletsService} from '../../services/billets.service';



@Component({
  selector: 'settings-component',
  templateUrl: './settings.component.html',
  imports: [
  ],
  styleUrl: './settings.component.less'
})
export class SettingsComponent {
  constructor(public SettingsService: SettingsService, public BilletsService: BilletsService,   private cd: ChangeDetectorRef){}

  open_settings = false;

  ngOnInit() {

    this.SettingsService.open_settings$
      .subscribe(value => {
        this.open_settings = value;
        this.cd.detectChanges();
      });

  }

  set_delete_statistics(){
    this.BilletsService.set_delete_statistics()
    this.SettingsService.set_open_settings(false)
  }

}
